module.exports = __webpack_public_path__ + "img/m1.32a9ab81.png";